import axios from "axios";
import { API } from "./client";

// Public endpoints (no credentials needed)
export const browseApi = {
  categories: async () => {
    const res = await axios.get(`${API}/browse/categories`);
    return res.data;
  },
  browse: async (species, params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const url = `${API}/browse/${species}${qs ? `?${qs}` : ""}`;
    const res = await axios.get(url);
    return res.data;
  },
  listing: async (listingId) => {
    const res = await axios.get(`${API}/listings/${listingId}`);
    return res.data;
  },
  search: async (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    const res = await axios.get(`${API}/search${qs ? `?${qs}` : ""}`);
    return res.data;
  },
};
